import { axiosInst } from './index';

//전체 카테고리 조회
function getAllCategory() {
	return axiosInst.get('/v1/category/getcategorylist');
}

export { getAllCategory };
